<template>
    <div class="xx-card">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'XxCard'
};
</script>

<style lang="scss" scoped>
.xx-card {
    background: #ffffff;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
    border-radius: 2px;
    padding: 20px;
    & + & {
        margin-top: 20px;
    }
}
</style>
